import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent4"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code4-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code4-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Buttons With Icon", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab4",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview4-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code4-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview4-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview4-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", { class: "d-flex gap-2 flex-wrap" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Primary ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Secondary ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success fw-medium text-white py-2 px-4"
            }, " Success "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Danger ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Warning ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Info ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Light ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-dark fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Dark ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link fw-medium text-white py-2 px-4"
            }, [
              _createElementVNode("i", { class: "ri-add-line" }),
              _createTextVNode(" Link ")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<button type=\"button\" class=\"btn btn-primary fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Primary</button>\n<button type=\"button\" class=\"btn btn-secondary fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Secondary</button>\n<button type=\"button\" class=\"btn btn-success fw-medium text-white py-2 px-4\">Success</button>\n<button type=\"button\" class=\"btn btn-danger fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Danger</button>\n<button type=\"button\" class=\"btn btn-warning fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Warning</button>\n<button type=\"button\" class=\"btn btn-info fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Info</button>\n<button type=\"button\" class=\"btn btn-light fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Light</button>\n<button type=\"button\" class=\"btn btn-dark fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Dark</button>\n<button type=\"button\" class=\"btn btn-link fw-medium text-white py-2 px-4\"><i class=\"ri-add-line\"></i> Link</button>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}